var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SectionSolution"},[(_vm.name)?_c('div',{staticClass:"head"},[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon.replace('_', '-')}}):_vm._e(),_c('h4',{class:{ long: _vm.name.length > 35 }},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1):_vm._e(),_c('div',{staticClass:"list"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }